/* Awtomic Build-a-Box customization — per-shop behavior + layout injection.
   Loaded by snippets/awtomic-theme-custom.liquid.
   Edit ONLY the SHOP CONFIG block below. Everything underneath hooks the
   Awtomic widget's own class names and works unchanged on any theme — do not
   edit it unless the widget markup itself has changed. */

/* ==================================================================== */
/* ===== SHOP CONFIG — EDIT THIS ====================================== */
/* ==================================================================== */

/* CONFIGURE: one entry per Build-a-Box bundle id — the number at the end of
   /tools/bundle-subscriptions/bundle/<id>. The "default" entry is the fallback
   for any bundle id not listed, so always keep it and give it real copy.
   Fields:
     title  — heading shown over the banner image
     header — HTML block shown above the product grid ("items header")
     info   — HTML for the description (left) + details box (right)
     img    — banner image: a full URL (e.g. a Shopify Files image) or a
              filename uploaded to this theme's assets/ */
const babInfoMapping = {
  // The Scheme — pick-your-own club (2-12 bottles per box).
  // Copy below is the merchant's FINAL wording, supplied verbatim by Emily
  // Yuhas on CX-4892. Do not paraphrase or re-punctuate it without asking.
  9525461680349: {
    title: "The Scheme",
    header: '<div class="main-bab-header"><h3>Build your box</h3><p>Choose between 2 and 12 bottles for your box</p></div>',
    info: `
      <div>
        <h3>The Scheme</h3>
        <p>Your wines, your schedule, your way. Choose from across the Ponzi Vineyards portfolio, including single-vineyard bottles available only to members. Start with two bottles or go deep with twelve. Adjust, add, or skip as life changes.</p>
      </div>
      <aside>
        <h4>Subscription Details</h4>
        <ul>
          <li>2 to 12 bottles per shipment</li>
          <li>Fully customizable, anytime</li>
          <li>Ships direct from the winery</li>
        </ul>
      </aside>
    `,
    // Banner image behind the "The Scheme" heading. Swap this URL to change the
    // picture: upload the new image in Shopify admin under Content -> Files,
    // copy its link, and paste it here. A bare filename also works if the image
    // is uploaded to this theme's assets/ folder instead.
    img: "https://cdn.shopify.com/s/files/1/0822/6960/2013/files/field.png?v=1785609393"
  },
  default: {
    title: "Ponzi Wine Club",
    header: '<div class="main-bab-header"><h3>Build your box</h3><p>Craft your own box—filled with the wines you love</p></div>',
    info: `
      <div>
        <h3>Build your box</h3>
        <p>Craft your own box—filled with the wines you love, delivered on your schedule.</p>
      </div>
      <aside>
        <h4>Subscription Details</h4>
        <ul>
          <li>Choose your favorite wines each shipment.</li>
          <li>Set deliveries on your schedule.</li>
          <li>Wines ship directly from the winery.</li>
        </ul>
      </aside>
    `,
    img: "https://cdn.shopify.com/s/files/1/0822/6960/2013/files/Aurora-Vineyard-Autumn-scaled.jpg?width=1600"
  }
};

/* CONFIGURE: optional minimum box price per club, enforced IN ADDITION to the
   widget's own bottle-count minimum. Shape:
     bundleId -> { variantId -> minimum price, ... }
   Leave empty ({}) to disable minimum-price enforcement entirely.

   The customer-portal gate matches a club by the VARIANT id carried on the
   Build-a-Box row (class `pv_<variant gid>`), so the inner keys must be the
   variant gids exactly as they appear there. Use one entry per club SIZE — a
   club whose size is not listed gets no minimum, silently.

   The outer key is the Build-a-Box bundle id (the number at the end of
   /tools/bundle-subscriptions/bundle/<id>). Only the PURCHASE-FLOW gate reads
   it from the page; the portal gate ignores it. Members join through the
   signup form here and no order is created at purchase, so the clubs below sit
   under a descriptive key: the portal is gated, the purchase flow deliberately
   is not. Swap in real bundle ids if the purchase flow ever needs the same
   minimums. */
const babMinimums = {
  "allocation-clubs": {
    // Variant gids come from the clubs_config default in
    // sections/wine-club-signup.liquid — keep the two in sync.
    "gid://shopify/ProductVariant/48037528207581": 700, // Basalt Club (12 bottles)
    "gid://shopify/ProductVariant/48037537382621": 350, // Loess Club (6 bottles)
    "gid://shopify/ProductVariant/48037577457885": 350, // Esclusivo Club (6 bottles)
    "gid://shopify/ProductVariant/48037593415901": 350, // Primo (6 bottles)
    "gid://shopify/ProductVariant/48037547376861": 200  // Rootstock Club (4 bottles)
    // The Scheme has no price minimum — its 2-12 bottle range is the only rule.
  }
};

/* CONFIGURE: which figure the minimum is compared against.
     "charged" — the discounted total the customer will actually be billed
                 (the emphasised number in the box footer). Default.
     "list"    — the pre-discount total.
   Only matters for clubs that carry a discount; with no discount the two are
   the same number. */
const babMinimumsCompare = "charged";

/* CONFIGURE: optional post-BaB upsell popup, shown after "add to cart".
   Leave variantId unset (or the whole object empty) and no popup appears —
   the customer goes straight to the cart. */
window.babUpsellConfig = {
  // variantId: 49231431958775,               // Shopify variant id added on Accept
  // heading: "Exclusive New Member Offer",
  // description: "Add this to your first shipment.",
  // productTitle: "Library Cabernet",
  // imageUrl: "https://cdn.shopify.com/...", // product image URL
  // priceLabel: "$45",
  // compareAtLabel: "$60",
};

/* CONFIGURE: optional external cancel-flow URL (no query string). When set,
   the customer-portal Cancel button opens
   <url>?winery=<shop>&token=<portal token>&sub=<subscription id> in a new tab
   instead of the widget's native cancel flow. Leave "" for native cancel. */
const babCancelRedirectUrl = "";

/* ==================================================================== */
/* ===== END SHOP CONFIG — do not edit below this line ================ */
/* ==================================================================== */

// Clean up hiddenStepper for non-BAB purchase flows
(function () {
  const isBabPurchaseFlow = window.location.pathname.includes("/tools/bundle-subscriptions/bundle/");

  if (!isBabPurchaseFlow) {
    // Immediate cleanup
    document.body.classList.remove("hiddenStepper");
    sessionStorage.removeItem("awtHiddenStepper");

    // Also cleanup on DOMContentLoaded to ensure it's removed
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        document.body.classList.remove("hiddenStepper");
        sessionStorage.removeItem("awtHiddenStepper");
      });
    }
  }
})();

// ===== Build-A-Box upsell popup =====
const babUpsell = (() => {
  let modalEl = null;
  let lastFocusedEl = null;

  const buildModal = () => {
    const cfg = window.babUpsellConfig || {};
    const wrap = document.createElement("div");
    wrap.className = "bab-upsell-modal";
    wrap.setAttribute("role", "dialog");
    wrap.setAttribute("aria-modal", "true");
    wrap.setAttribute("aria-labelledby", "bab-upsell-title");
    wrap.setAttribute("aria-hidden", "true");
    wrap.innerHTML = `
      <div class="bab-upsell-modal__dialog" tabindex="-1">
        <button type="button" class="bab-upsell-modal__close" data-bab-upsell-close aria-label="Close">&times;</button>
        <h2 class="bab-upsell-modal__title" id="bab-upsell-title">${escapeHtml(cfg.heading || "Exclusive New Member Offer")}</h2>
        <p class="bab-upsell-modal__subtitle">${escapeHtml(cfg.description || "")}</p>
        <div class="bab-upsell-modal__product">
          <div class="bab-upsell-modal__image-wrap">
            ${cfg.imageUrl ? `<img src="${escapeAttr(cfg.imageUrl)}" alt="${escapeAttr(cfg.productTitle || "")}" />` : ""}
          </div>
          <h3 class="bab-upsell-modal__product-title">${escapeHtml(cfg.productTitle || "")}</h3>
          <div class="bab-upsell-modal__pricing">
            ${cfg.compareAtLabel ? `<div class="bab-upsell-modal__compare-at">Price: <span>${escapeHtml(cfg.compareAtLabel)}</span></div>` : ""}
            <div class="bab-upsell-modal__offer">Offer Price: <span>${escapeHtml(cfg.priceLabel || "")}</span></div>
          </div>
        </div>
        <div class="bab-upsell-modal__actions">
          <button type="button" class="bab-upsell-modal__btn bab-upsell-modal__accept" data-bab-upsell-accept>Accept</button>
          <button type="button" class="bab-upsell-modal__btn bab-upsell-modal__decline" data-bab-upsell-decline>Decline</button>
        </div>
      </div>
    `;
    document.body.appendChild(wrap);
    return wrap;
  };

  const escapeHtml = (str) => String(str).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const escapeAttr = (str) => escapeHtml(str);

  const finish = (discount) => {
    if (discount) {
      window.location.assign(`/discount/${encodeURIComponent(discount)}?redirect=/cart`);
    } else {
      window.location.assign("/cart");
    }
  };

  const close = () => {
    if (!modalEl) return;
    modalEl.classList.remove("bab-upsell-modal--open");
    modalEl.setAttribute("aria-hidden", "true");
    document.body.classList.remove("bab-upsell-locked");
    document.removeEventListener("keydown", onKeydown);
    if (lastFocusedEl && typeof lastFocusedEl.focus === "function") {
      lastFocusedEl.focus();
    }
  };

  const onKeydown = (e) => {
    if (e.key === "Escape") {
      e.preventDefault();
      const decline = modalEl?.querySelector("[data-bab-upsell-decline]");
      decline?.click();
    }
  };

  const open = (discount) => {
    if (!modalEl) modalEl = buildModal();
    const cfg = window.babUpsellConfig || {};
    if (!cfg.variantId) {
      console.warn("[bab-upsell] No variantId configured; skipping popup");
      finish(discount);
      return;
    }

    lastFocusedEl = document.activeElement;
    modalEl.classList.add("bab-upsell-modal--open");
    modalEl.setAttribute("aria-hidden", "false");
    document.body.classList.add("bab-upsell-locked");

    const dialog = modalEl.querySelector(".bab-upsell-modal__dialog");
    dialog?.focus();

    const acceptBtn = modalEl.querySelector("[data-bab-upsell-accept]");
    const declineBtn = modalEl.querySelector("[data-bab-upsell-decline]");
    const closeBtn = modalEl.querySelector("[data-bab-upsell-close]");

    const handleDecline = (e) => {
      e?.preventDefault();
      close();
      finish(discount);
    };

    const handleAccept = async (e) => {
      e?.preventDefault();
      acceptBtn.disabled = true;
      declineBtn.disabled = true;
      closeBtn.disabled = true;
      try {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: [{ id: cfg.variantId, quantity: 1 }] })
        });
      } catch (err) {
        console.error("[bab-upsell] add-to-cart failed", err);
      }
      finish(discount);
    };

    const handleBackdrop = (e) => {
      if (e.target === modalEl) handleDecline(e);
    };

    acceptBtn.onclick = handleAccept;
    declineBtn.onclick = handleDecline;
    closeBtn.onclick = handleDecline;
    modalEl.onclick = handleBackdrop;
    document.addEventListener("keydown", onKeydown);
  };

  return { open };
})();

window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    productImage: 600, /* CONFIGURE (optional): BaB product image size in px */
    addToCartRedirect: ({ discount } = {}) => {
      babUpsell.open(discount);
    }
  }
});

const waitForElement = (selector, callback, delay = 0, failsafeDelay) => {
  const observer = new MutationObserver((mutations, obs) => {
    const element = document.querySelector(selector);
    if (element) {
      obs.disconnect();
      if (typeof callback === "function") {
        setTimeout(() => {
          callback(element);
        }, delay);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (failsafeDelay) setTimeout(() => observer.disconnect(), failsafeDelay);
};

//if awtomic customer portal
if (window.location.pathname.includes("/tools/bundle-subscriptions") && window.location.search.includes("subscriptionId=")) {
  document.body.classList.add("awt-cp");

  // Intercept cancel button and redirect to external cancellation flow
  // (only when babCancelRedirectUrl is configured above)
  if (babCancelRedirectUrl) {
    waitForElement(".bundle-button--cancel", (originalBtn) => {
      originalBtn.style.display = "none";

      const clonedBtn = originalBtn.cloneNode(true);
      clonedBtn.style.display = "";
      clonedBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        const rawSubscriptionId = window.Awtomic?.subscriptionDetails?.SubscriptionId || "";
        const subscriptionId = rawSubscriptionId.split("/").pop();
        const winery = window.Shopify?.shop || "";
        const token = (() => {
          try {
            const raw = localStorage.getItem("awtomicApiAuth");
            return raw ? JSON.parse(raw).authToken || "" : "";
          } catch { return ""; }
        })();

        window.open(
          `${babCancelRedirectUrl}?winery=${encodeURIComponent(winery)}&token=${encodeURIComponent(token)}&sub=${subscriptionId}`,
          "_blank"
        );
      });

      originalBtn.parentNode.insertBefore(clonedBtn, originalBtn.nextSibling);
    });
  }

  /* ---- CP minimum-price gate -------------------------------------------
     Keeps the box-editor Save button unusable while the box total is under
     the club's minimum. This only ever ADDS a condition on top of the
     widget's own bottle-count rule — it never enables a button the widget
     has disabled.

     Identifying the club: the editor itself renders no club id, so the club
     is taken from the portal row the customer clicked. That row carries the
     club's variant gid in its class (`pv_<gid>`).

     Which price: the footer shows the box total, and when a club discount
     applies it shows both the struck-through list total and the emphasised
     discounted total. `babMinimumsCompare` above picks which one counts;
     the default is the discounted total, i.e. what the customer is billed.
     Add-ons (` + $x` in the same footer) are excluded — the minimum is on
     the club box.

     Everything below registers ONCE for the page: one delegated row-click
     listener, one capture-phase click blocker, one observer. Nothing is
     re-bound per modal open. */
  (() => {
    const BLOCKED_BODY_CLASS = "awt-below-club-min";
    const BLOCKED_BTN_CLASS = "awt-min-blocked";
    const MSG_CLASS = "awt-min-price-info";
    const LABEL_CLASS = "awt-min-label";
    const SAVE_BUTTONS = ".awt-bundle-update-save-button, .awt-bundle-update-submit-button";

    // Reduce any variant reference to its bare numeric id, so a config key
    // written as a full gid and a DOM class written as a plain number resolve
    // to the SAME entry. Both shapes are in use in this codebase, and keying
    // on one of them makes the lookup silently return undefined for the other.
    const variantKey = (value) => String(value).split("/").pop();

    // bare variant id -> minimum. Flattened so the bundle-id level, which the
    // portal has no way to read, is never needed here.
    const minimumByVariant = {};
    Object.keys(babMinimums || {}).forEach((bundleId) => {
      const perVariant = babMinimums[bundleId] || {};
      Object.keys(perVariant).forEach((variantId) => {
        minimumByVariant[variantKey(variantId)] = perVariant[variantId];
      });
    });
    if (!Object.keys(minimumByVariant).length) return;

    let activeMinimum = 0;

    const parseMoney = (text) => {
      if (!text) return NaN;
      // Intl currency output, e.g. "$1,234.56" — strip the symbol and every
      // thousands separator, not just the first one.
      return parseFloat(String(text).replace(/[^0-9.,]/g, "").replace(/,/g, ""));
    };

    // Reuse whatever currency prefix/suffix the widget rendered, so the
    // message matches the shop's own formatting.
    const formatLikeFooter = (amount) => {
      const sample = document.querySelector(".awt-bundle-update-footer-base-price");
      const text = sample ? sample.textContent.trim() : "";
      const symbol = text ? text.replace(/[0-9.,\s]/g, "") : "$";
      return symbol + amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    // NaN means "no total on screen yet" — never treated as below the
    // minimum, so a slow render can't block a customer who is compliant.
    const readBoxTotal = () => {
      const wrap = document.querySelector(".awt-bundle-update-footer-price");
      if (!wrap) return NaN;
      const discounted = wrap.querySelector(".awt-bundle-update-footer-discounted-price");
      const list = wrap.querySelector(".awt-bundle-update-footer-base-price");
      const node = babMinimumsCompare === "list" ? list : (discounted || list);
      return node ? parseMoney(node.textContent) : NaN;
    };

    const minimumFromRow = (row) => {
      const token = Array.from(row.classList).find((c) => c.indexOf("pv_") === 0);
      if (!token) return 0;
      return minimumByVariant[variantKey(token.slice(3))] || 0;
    };

    /* Emily, CX-4891 c#70428: state the minimum on the club's own label, so a
       member who is already above it still learns the rule exists — the
       in-editor message only ever appears once they are short.
       The amount is read from `babMinimums` above, never re-typed, so there is
       only ever one place to change it. */
    const annotateRowLabels = () => {
      document.querySelectorAll(".bundle-table__body-row--bab-parent").forEach((row) => {
        const name = row.querySelector(".bundle-product-name");
        if (!name) return;
        const minimum = minimumFromRow(row);
        let tag = name.querySelector("." + LABEL_CLASS);
        if (!minimum) {
          if (tag) tag.remove();
          return;
        }
        if (!tag) {
          tag = document.createElement("span");
          tag.className = LABEL_CLASS;
          name.appendChild(tag);
        }
        // Appended as its own node rather than rewritten into the name's text,
        // so the widget's own title content is never clobbered.
        const text = " and " + formatLikeFooter(minimum) + " Minimum required";
        // Same rule as renderMessage: the observer watches this subtree, so an
        // unconditional write would re-trigger itself forever.
        if (tag.textContent !== text) tag.textContent = text;
      });
    };

    const renderMessage = (shortfall) => {
      const footer = document.querySelector(".awt-bundle-update-content-footer");
      if (!footer) return;
      let msg = footer.querySelector("." + MSG_CLASS);
      if (!shortfall) {
        if (msg) msg.remove();
        return;
      }
      if (!msg) {
        msg = document.createElement("div");
        msg.className = MSG_CLASS;
        msg.setAttribute("role", "status");
        footer.insertBefore(msg, footer.firstChild);
      }
      const text =
        "This club has a " + formatLikeFooter(activeMinimum) +
        " minimum. Add " + formatLikeFooter(shortfall) + " more to save your changes.";
      // Only write when it actually changed — the observer below watches this
      // subtree, and an unconditional write would re-trigger itself forever.
      if (msg.textContent !== text) msg.textContent = text;
    };

    const evaluate = () => {
      const total = activeMinimum ? readBoxTotal() : NaN;
      const below = !!activeMinimum && !isNaN(total) && total < activeMinimum;

      document.body.classList.toggle(BLOCKED_BODY_CLASS, below);
      document.querySelectorAll(SAVE_BUTTONS).forEach((btn) => {
        btn.classList.toggle(BLOCKED_BTN_CLASS, below);
        // The widget owns this attribute and rewrites it on re-render; the
        // observer below re-applies ours on the next tick, so it self-heals.
        if (below) btn.setAttribute("aria-disabled", "true");
      });
      renderMessage(below ? activeMinimum - total : 0);
    };

    let queued = false;
    const scheduleEvaluate = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        evaluate();
        // Runs regardless of activeMinimum — the labels belong to the list, not
        // to an open editor.
        annotateRowLabels();
      });
    };

    // The observer below only fires on a mutation; the rows may already be on
    // screen by the time this runs, so paint them once up front.
    scheduleEvaluate();

    // Capture the club as the customer opens the editor.
    document.addEventListener("click", (e) => {
      const row = e.target.closest && e.target.closest(".bundle-table__body-row--bab-parent");
      if (!row) return;
      activeMinimum = minimumFromRow(row);
      scheduleEvaluate();
    }, true);

    // Capture phase, so the click never reaches the widget's own handler.
    document.addEventListener("click", (e) => {
      if (!document.body.classList.contains(BLOCKED_BODY_CLASS)) return;
      const btn = e.target.closest && e.target.closest(SAVE_BUTTONS);
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      const msg = document.querySelector("." + MSG_CLASS);
      if (msg) {
        msg.classList.add(MSG_CLASS + "--flash");
        setTimeout(() => msg.classList.remove(MSG_CLASS + "--flash"), 1200);
      }
    }, true);

    // Re-check whenever the editor re-renders (selection, tier, discount).
    new MutationObserver(scheduleEvaluate).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    // Closing the editor clears the gate so the portal behind it is untouched.
    window.addEventListener("awtomic-box-edit-modal-closed", () => {
      activeMinimum = 0;
      evaluate();
    });
  })();
}

//if awtomic subs list / my subscriptions
if (/^\/tools\/bundle-subscriptions\/?$/.test(location.pathname) && !location.search) {
  document.body.classList.add("awt-my-subs");
}

//if awtomic bab purchase flow
if (window.location.pathname.includes("/tools/bundle-subscriptions/bundle/")) {
  // Check if coming from product PDP
  const referrer = document.referrer;
  const fromPDP = referrer && referrer.includes("/products/");

  if (fromPDP) {
    document.body.classList.add("hiddenStepper");
    sessionStorage.setItem("awtHiddenStepper", "true");
  } else if (sessionStorage.getItem("awtHiddenStepper") === "true") {
    document.body.classList.add("hiddenStepper");
  }

  window.Awtomic = window.Awtomic || {};
  window.Awtomic.getBabSelection = () => {
    //babProductId is in a class of an element, the element is div.bundle-container.pv_xxxxxxx where xxxxxxx is the bab product id
    const babProductId = document
      .querySelector(".bundle-container")
      ?.className.split(" ")
      .find((c) => c.startsWith("pv_"))
      ?.split("_")[1];
    if (!babProductId) return { object: {}, queryString: "" };

    const bundleProductCards = document.querySelectorAll(".bundle-product-card");

    const bundleSelectedProducts = {};
    bundleProductCards.forEach((card) => {
      const productId = card.getAttribute("data-pid");
      const quantityElement = card.querySelector(".bundle-product-card__quantity-button-container > span");
      const quantity = quantityElement ? parseInt(quantityElement.innerHTML) : 0;

      if (productId && quantity > 0) {
        bundleSelectedProducts[productId] = quantity;
      }
    });

    // Create query string format
    const queryString = Object.entries(bundleSelectedProducts)
      .map(([id, quantity]) => `${id}=${quantity}`)
      .join("&");

    // Create full URL with query string
    const currentUrl = window.location.href;
    const separator = currentUrl.includes("?") ? "&" : "?";
    const fullUrl = queryString ? `${currentUrl}${separator}${queryString}` : currentUrl;

    return {
      object: { [babProductId]: bundleSelectedProducts },
      queryString: queryString,
      fullUrl: fullUrl
    };
  };

  const urlParts = window.location.pathname.split("/");
  const bundleId = urlParts[urlParts.length - 1];
  if (bundleId) {
    document.body.classList.add(`awt-bundle-${bundleId}`);

    if (babMinimums[bundleId]) {
      // Wait for footer to exist first, then set up the price checking
      waitForElement(".bundleapp-modal__container--complete-screen footer", () => {
        // Get variant ID from bundle container classes (e.g., div.bundle-container p_9556565229815.pv_49231431991543)
        const getVariantId = () => {
          const bundleContainer = document.querySelector(".bundle-container");
          if (!bundleContainer) return null;

          const classes = bundleContainer.className.split(" ");
          const variantClass = classes.find((c) => c.startsWith("pv_"));
          return variantClass ? variantClass.split("_")[1] : null;
        };

        let currentVariantId = getVariantId();

        const updatePriceChecking = (variantId) => {
          const minimumPrice = babMinimums[bundleId]?.[variantId] || 0;
          console.log(`Setting up price checking for variant ${variantId} with minimum price $${minimumPrice}`);

          const setAddToCartMinimumPrice = () => {
            const bundleContainer = document.querySelector(".bundleapp-modal__container--complete-screen > .bundle-container");

            if (!bundleContainer) return;

            // Remove existing minimum price info if any
            const existingInfo = bundleContainer.querySelector(".minimum-price-info");
            if (existingInfo) {
              existingInfo.remove();
            }

            const infoDiv = document.createElement("div");
            infoDiv.className = "minimum-price-info";
            infoDiv.innerText = `Minimum price of $${minimumPrice} is required for this club.`;

            const footerDiv = bundleContainer.querySelector("footer > div");
            if (footerDiv) {
              const lastDiv = footerDiv.querySelector("div:last-child");
              if (lastDiv) {
                footerDiv.insertBefore(infoDiv, lastDiv);
              }
            }

            document.body.addEventListener("click", (e) => {
              const price = document.querySelector("div > span.bundle-text--emphasis").innerText;
              const innerPrice = parseFloat(price.replace(/[^0-9.,]/g, "").replace(",", ""));

              const addToCartButton = document.querySelector(".bundleapp-modal__container--complete-screen footer > div > div > button");
              if (innerPrice < minimumPrice) {
                addToCartButton.classList.add("priceNotMet");
                document.body.classList.add("priceNotMet");
              } else {
                addToCartButton.classList.remove("priceNotMet");
                document.body.classList.remove("priceNotMet");
              }
            });
          };

          const checkIfPriceLabel = () =>
            document.querySelector(".bundleapp-modal__container--complete-screen footer > div > div:last-child > div > span:nth-child(2)");

          let priceLabelSet = false;

          if (checkIfPriceLabel()) {
            setAddToCartMinimumPrice();
          } else {
            const observer = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                if (!priceLabelSet && mutation.addedNodes.length) {
                  if (checkIfPriceLabel()) {
                    setAddToCartMinimumPrice();
                    priceLabelSet = true;
                    observer.disconnect();
                  }
                }
              });
            });

            observer.observe(document.body, {
              childList: true,
              subtree: true
            });

            setTimeout(() => {
              observer.disconnect();
            }, 5000);
          }
        };

        // Initial setup if we have a variant ID
        if (currentVariantId) {
          updatePriceChecking(currentVariantId);
        }

        // Watch for variant changes in the bundle container
        const variantObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === "attributes" && mutation.attributeName === "class") {
              const newVariantId = getVariantId();
              if (newVariantId && newVariantId !== currentVariantId) {
                console.log(`Variant changed from ${currentVariantId} to ${newVariantId}`);
                currentVariantId = newVariantId;
                updatePriceChecking(currentVariantId);
              }
            }
          });
        });

        // Observe the bundle container for class changes
        const bundleContainer = document.querySelector(".bundle-container");
        if (bundleContainer) {
          variantObserver.observe(bundleContainer, {
            attributes: true,
            attributeFilter: ["class"]
          });
        }
      });
    }

    //Add subscription info blocks for all bundle products
    waitForElement(".bundleapp-modal__container--complete-screen .bundle-container", (container) => {
      const imgId = "bundle-subscription-placeholder-img";

      if (!document.getElementById(imgId)) {
        // Insert image container
        var imgContainer = document.createElement("div");
        imgContainer.className = "bundle-subscription-placeholder-img-container";

        var img = document.createElement("img");
        const imgFilename = babInfoMapping[bundleId]?.img || babInfoMapping.default.img;
        // img may be a full URL (e.g. a Shopify Files image) or a filename
        // uploaded to this theme's assets/ (resolved via the awtAssetPath shim).
        img.src = /^https?:\/\//.test(imgFilename)
          ? imgFilename
          : window.awtAssetPath.replace("xxxxxxxx.jpg", imgFilename);
        img.id = imgId;
        imgContainer.appendChild(img);

        var imgText = document.createElement("div");
        imgText.className = "bundle-subscription-placeholder-img-text";
        imgText.innerHTML = `<h1>${babInfoMapping[bundleId]?.title || babInfoMapping.default.title}</h1>`;
        imgContainer.appendChild(imgText);

        container.insertBefore(imgContainer, container.firstChild);

        // Insert subscription info block
        var info = document.createElement("div");
        info.className = "bundle-subscription-info";
        info.innerHTML = babInfoMapping[bundleId]?.info || babInfoMapping.default.info;
        container.insertBefore(info, imgContainer.nextSibling);

        // Insert items header before create-content
        const createContent = document.querySelector(".bundle-create-content");
        if (createContent) {
          var itemsheader = document.createElement("div");
          itemsheader.className = "bundle-subscription-itemsheader";
          itemsheader.innerHTML = babInfoMapping[bundleId]?.header || babInfoMapping.default.header;
          container.insertBefore(itemsheader, createContent);
        }
      }
    });
  }
}
